module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-04.9a007903.jpg";